module.exports = __webpack_public_path__ + "static/media/bank-details.d6327a53.svg";